
import { mapState } from "vuex";
import MajorTable from "../components/MajorTable.vue";
import Section from "../components/Section.vue";

export default {
  props: {
    searchDefault: {
      type: String,
      default: "",
    },
    setComponent: {
      type: Function,
      default: () => { },
    },
    setMajorName: {
      type: Function,
      default: () => { },
    },
  },
  computed: {
    ...mapState("Major", ["listGroupByMajorName"]),
  },
  mounted() {
    this.getListGroupMajors(this.searchDefault);
  },
  data() {
    return {
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
      majorSearch: this.searchDefault,
    };
  },
  watch: {
    majorSearch(newValue, oldValue) {
      if (newValue.length === 0) {
        // console.log("getlistgroupmajow");
        this.getListGroupMajors(this.majorSearch);
      }
    },
  },
  components: { Section, MajorTable },
  methods: {
    handleChange(value) {
      console.log(`selected ${value}`);
    },
    async getListGroupMajors(majorName) {
      this.$store.dispatch("Major/getListGroupByMajorName", majorName);
    },
    async onKeyPress(e) {
      if (e.key === "Enter") {
        // console.log({ search: this.majorSearch });
        await this.getListGroupMajors(this.majorSearch);
        // this.majorSearch = "";
      }
    },
    handleTableClick(data) {
      this.setComponent("MajorDes");
      this.setMajorName(data);
    },
  },
};
